import * as React from 'react';
import { Body1, Link } from '@cian/ui-kit';

import { IRoomStatsCellValue } from '../../../../../../types/newbuildingsCompare';
import { getNewbuildingIdFromUrl } from '../shared/getNewbuildingIdFromUrl';
import { trackNavigationToListingJK } from '../shared/tracking';
import * as style from './style.css';

export interface IRoomStatsCellMobileProps {
  data: IRoomStatsCellValue;
}

export const RoomStatsCellMobile = ({ data }: IRoomStatsCellMobileProps): React.JSX.Element => {
  const handleLinkClick = React.useCallback(() => {
    trackNavigationToListingJK(getNewbuildingIdFromUrl(data.roomLink.url));
  }, [data]);

  return (
    <div className={style['container-mobile']}>
      <Link href={data.roomLink.url} target="_blank" onClick={handleLinkClick}>
        {data.roomLink.text}
      </Link>
      {data.priceRange && (
        <div className={style['price']}>
          <Body1 color="text-primary-default">{data.priceRange}</Body1>
        </div>
      )}
      {data.minArea && (
        <div className={style['area']}>
          <Body1 color="text-secondary-default">{data.minArea}</Body1>
        </div>
      )}
    </div>
  );
};
